import { render, staticRenderFns } from "./IntegrationSetup.vue?vue&type=template&id=614a78ba&scoped=true&"
import script from "./IntegrationSetup.vue?vue&type=script&lang=ts&"
export * from "./IntegrationSetup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "614a78ba",
  null
  
)

export default component.exports